
export default {
	components: {
		product: () => import('../../components/product/product.vue')
	}
};
